import {EnterpriseEntitlementV2} from "@common-core/coat-operational-hierarchy-appsync-model";

export const isEntitlementActive = (
  entitlement: EnterpriseEntitlementV2
): boolean => {
  return entitlement.status?.toLowerCase() === "active";
};
